export const DATE_FORMAT_FOR_UI = 'MM/DD/YYYY';
export const DATE_FORMAT_FOR_UI_DASHED = 'MM-DD-YYYY';
export const DATE_TIME_FORMAT_FOR_UI = `${DATE_FORMAT_FOR_UI}  LT`;
export const DATE_FORMAT_FOR_SERVER = 'YYYY-MM-DD';
export const DATE_FORMAT_TRANSACTION_HISTORY = 'YYYY-MM-DD hh:mm:ss';
export const MONTH_YEAR_DATE_FORMAT = 'MM/YYYY';
export const DATE_FORMAT_WITH_DAY_FOR_UI = `ddd ${DATE_FORMAT_FOR_UI}`;
export const DATE_FORMAT_WITH_FULL_DAY_FOR_UI = `dddd, ${DATE_FORMAT_FOR_UI}`;
export const DATE_FORMAT_FOR_DB_STRING = 'YYYYMMDD';
export const DATE_FORMAT_DATE_TIME_12H = 'MM/DD/YYYY hh:mm:ss a';
export const DATE_FORMAT_DAY_MONTH_NUMBER = 'ddd, MMM D';
export const DATE_FORMAT_DAY_OF_WEEK = 'dddd';
export const DATE_FORMAT_FOR_EXPORT = 'MM_DD_YYYY';



// WEBPACK FOOTER //
// ./src/common/Constants/dateformat.js